import { useEffect, useState } from 'react';
import { bg, line, tx, font, accent, space, radius } from '../theme';
import { listAnnouncements } from './accountApi';

function Screen({ children }) {
  return (
    <div style={{
      minHeight: '50vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      color: tx.muted, fontFamily: font.display, fontSize: 12,
      letterSpacing: '0.2em', textTransform: 'uppercase',
    }}>{children}</div>
  );
}

export default function News() {
  const [news, setNews] = useState([]);
  const [status, setStatus] = useState('loading');

  useEffect(() => {
    let alive = true;
    (async () => {
      const { data, error } = await listAnnouncements();
      if (!alive) return;
      if (error) { setStatus('error'); return; }
      setNews(data || []);
      setStatus('ready');
    })();
    return () => { alive = false; };
  }, []);

  return (
    <div style={{ maxWidth: 820, margin: '0 auto', padding: space.s6 }}>
      <div style={{ marginBottom: space.s6 }}>
        <div style={{
          fontFamily: font.display, fontSize: 11, fontWeight: 700,
          letterSpacing: '0.24em', textTransform: 'uppercase',
          color: accent.lime, marginBottom: space.s2,
        }}>
          The latest
        </div>
        <h1 style={{ fontFamily: font.display, fontSize: 30, fontWeight: 700, margin: 0 }}>
          Groundwork news.
        </h1>
        <p style={{ color: tx.secondary, marginTop: space.s3, maxWidth: '58ch' }}>
          Updates, changes and what&rsquo;s coming next.
        </p>
      </div>

      {status === 'loading' && <Screen>Loading</Screen>}
      {status === 'error' && <Screen>Couldn&rsquo;t load the news</Screen>}
      {status === 'ready' && news.length === 0 && <Screen>Nothing new right now</Screen>}

      {news.map((n) => (
        <article key={n.id} style={{
          background: bg.surface, border: `1px solid ${line.DEFAULT}`,
          borderLeft: `3px solid ${n.pinned ? accent.lime : line.strong}`,
          borderRadius: radius.md, padding: space.s5, marginBottom: space.s4,
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: space.s3, marginBottom: space.s3 }}>
            {n.tag && (
              <span style={{
                fontFamily: font.display, fontSize: 10.5, fontWeight: 700, letterSpacing: '0.14em',
                textTransform: 'uppercase', color: accent.lime,
              }}>{n.tag}</span>
            )}
            <span style={{ fontFamily: font.data, fontSize: 11.5, color: tx.faint, marginLeft: 'auto' }}>
              {new Date(n.created_at).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' })}
            </span>
          </div>
          <div style={{ fontFamily: font.display, fontWeight: 700, fontSize: 18, marginBottom: space.s3 }}>{n.title}</div>
          <p style={{ color: tx.secondary, fontSize: 14.5, lineHeight: 1.65, margin: 0, whiteSpace: 'pre-wrap' }}>{n.body}</p>
        </article>
      ))}
    </div>
  );
}
